import { render, staticRenderFns } from "./HeartysanChatModule.vue?vue&type=template&id=1e783ece&scoped=true"
import script from "./HeartysanChatModule.vue?vue&type=script&lang=js"
export * from "./HeartysanChatModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e783ece",
  null
  
)

export default component.exports